import { CarbonForIbmDotcom } from "@carbon/pictograms-react";
import { ArtTools_01 } from "@carbon/pictograms-react";
import { FileBackup } from "@carbon/pictograms-react";
import * as React from 'react';
export default {
  CarbonForIbmDotcom,
  ArtTools_01,
  FileBackup,
  React
};